<style>
#hydrantCardModal .v--modal-box.v--modal {
  min-height: 360px !important;
  min-width: 700px !important;
}
#hydrantCardModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#hydrantCardModal .complete-inspection__background {
  background-color: #c4cbe0;
  color: rgba(42, 87, 154, 1);
  height: 40px;
  text-align: center;
  line-height: 40px;
}
#hydrantCardModal .complete-inspection__background:hover {
  cursor: pointer;
}
#hydrantCardModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#hydrantCardModal .v-select__selection {
  font-size: 12px !important;
}
#hydrantCardModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#hydrantCardModal .modal__content > div {
  height: 100% !important;
}
#hydrantCardModal .inspectionMissed .v-text-field__slot > input {
  color: red !important;
}
#hydrantCardModal .accent--text {
  color: #4f7052 !important;
  caret-color: #4f7052 !important;
}
</style>

<template>
  <Modal
    modalName="hydrantCardModal"
    @closed="closed()"
    @editingCancel="cancelEditing()"
    @editingSave="saveEditing()"
    @editingStart="startEditing()"
    @opened="updateList(), loadDict()"
    @print="print()"
    :buttons="['print']"
    :editing="editing"
    :module="module"
    :title="`KARTA HYDRANTU O ID ${hydrantData.id}`"
  >
    <div>
      <v-tabs
        color="#2a579a"
        dark
        centered
        grow
        active-class="tab--active"
        :hide-slider="true"
        height="35"
      >
        <v-tab>ATRYBUTY</v-tab>
        <v-tab-item>
          <v-card flat id="attr__wrapper">
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader>DANE TECHNICZNE</v-subheader>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="lastInspectionDate"
                  readonly
                  label="Data ostatniego przeglądu"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="nextInspectionDate"
                  readonly
                  label="Data kolejnego przeglądu"
                  :class="{ inspectionMissed: isMissedInspection }"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-select
                  :items="statuses"
                  v-model="hydrantData.status"
                  label="Status"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  :readonly="!editing"
                ></v-select>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.net_kind"
                  :readonly="!editing"
                  label="Rodzaj sieci"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.model_elevation"
                  :readonly="!editing"
                  label="Rzędna terenu"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="hydrantKinds"
                  v-model="hydrantData.hydrant_kind"
                  label="Rodzaj hydrantu"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  :readonly="!editing"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.base_height"
                  :readonly="!editing"
                  label="Wysokość nasady"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.diameter"
                  :readonly="!editing"
                  label="Średnica"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.efficiency"
                  :readonly="!editing"
                  label="Pomierzona wydajność"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="producers"
                  v-model="hydrantData.producer"
                  label="Producent"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  :readonly="!editing"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.pressure"
                  :readonly="!editing"
                  label="Pomierzone ciśnienie"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.year"
                  :readonly="!editing"
                  label="Rok budowy"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="!editing"
                >
                  <template :readonly="!editing" v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedMeasureDateFormatted"
                      label="Data pomiaru"
                      prepend-icon="event"
                      :readonly="!editing"
                      @input="
                        hydrantData.measure_date = parseDate(
                          computedMeasureDateFormatted
                        )
                      "
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="hydrantData.measure_date"
                    @input="dateMenu = false"
                    color="#2a579a"
                    no-title
                    :readonly="!editing"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="valves"
                  v-model="hydrantData.valve"
                  label="Zasuwa"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  :readonly="!editing"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.registry_exploitation"
                  :readonly="!editing"
                  label="Numer eksploatacyjny"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.comments"
                  :readonly="!editing"
                  label="Uwagi"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.inventory"
                  :readonly="!editing"
                  label="Ewidencja"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.acquisition"
                  :readonly="!editing"
                  label="Sposób pozyskania danych"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader>DANE ADRESOWE</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.address_place"
                  :readonly="!editing"
                  label="Miejscowość"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.address_street"
                  :readonly="!editing"
                  label="Ulica"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.address_order"
                  :readonly="!editing"
                  label="Numer porządkowy"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="hydrantData.address_plot"
                  :readonly="!editing"
                  label="Numer działki"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>

        <v-tab>PRZEGLĄDY</v-tab>
        <v-tab-item>
          <v-card flat style="height: 100%">
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader
                  >DODAWANIE NOWEGO PRZEGLĄDU DLA HYDRANTU O ID
                  {{ hydrantData.id }}</v-subheader
                >
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-menu
                  v-model="dateMenu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedInspectionDateFormatted"
                      label="Data pomiaru"
                      prepend-icon="event"
                      @input="
                        newHydrantData.inspection_date = parseDate(
                          computedInspectionDateFormatted
                        )
                      "
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newHydrantData.inspection_date"
                    @input="dateMenu2 = false"
                    color="#2a579a"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="users"
                  item-text="name"
                  item-value="id"
                  no-data-text="Brak użytkowników"
                  v-model="newHydrantData.user_id"
                  label="Inspektor wykonującego przegląd"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="newHydrantData.static_pressure_value"
                  label="Ciśnienie statyczne"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="newHydrantData.dynamic_pressure_value"
                  label="Ciśnienie dynamiczne"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="newHydrantData.flow_rate_value"
                  label="Natężenie wypływu"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-list style="width: 100%">
                  <template v-for="(value, key) in parametersFields">
                    <v-list-tile
                      class="list--el"
                      style="border-bottom: 1px solid lightgrey"
                      :key="key"
                    >
                      <v-list-tile-content
                        @click="newHydrantData[key] = !newHydrantData[key]"
                      >
                        <v-list-tile-title>{{ value }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-checkbox
                          class="checkbox--big"
                          v-model="newHydrantData[key]"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="newHydrantData.comments"
                  label="Opis"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 style="text-align: center;">
                <v-btn dark color="success" @click="addNewInspection"
                  >ZAPISZ WYKONANY PRZEGLĄD</v-btn
                >
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-subheader>PRZEGLĄDY PRZYPISANE DO HYDRANTU</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <InspectionsTable
                  style="height: 175px"
                  :hydrant="hydrantData.id"
                  :last_only="false"
                ></InspectionsTable>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>

        <v-tab
          v-if="
            featureEvents != undefined && featureEvents.hasOwnProperty('events')
          "
          >ZDARZENIA ({{ featureEvents.events_count }})</v-tab
        >
        <v-tab v-else>ZDARZENIA (0)</v-tab>
        <v-tab-item>
          <v-card flat>
            <Events
              style="margin-top: 15px"
              :featureEvents="featureEvents"
              :objectType="objectType"
              :objectTable="objectTable"
              :id="hydrantData.id"
              :module="module"
            />
          </v-card>
        </v-tab-item>

        <v-tab v-if="attachmentsArr.hasOwnProperty('data')"
          >ZAŁĄCZNIKI ({{ attachmentsArr.data.length }})</v-tab
        >
        <v-tab-item>
          <v-layout row>
            <v-flex
              xs12
              v-if="
                $can('read', 'inspections_attachments') ||
                  $can('edit', 'inspections_attachments')
              "
            >
              <v-subheader class="font--primary"
                >POWIĄZANE ZAŁĄCZNIKI</v-subheader
              >
              <div
                v-if="
                  ifAttachments.hasOwnProperty('data') &&
                    ifAttachments.data.length > 0
                "
              >
                <li
                  class="list__container--el"
                  v-for="(index, key) in attachmentsArr.data"
                  :key="key"
                >
                  <span>{{ index.id }} - {{ index.filename }}</span>
                  <span>
                    <v-icon
                      @click="downloadAttachment(index.id, index.filename)"
                      small
                      title="Pobierz załącznik"
                      v-if="
                        $can('read', 'inspections_attachments') ||
                          $can('edit', 'inspections_attachments')
                      "
                      >cloud_download</v-icon
                    >
                    <v-icon
                      @click="deleteAttachment(index.id)"
                      small
                      title="Usuń załącznik"
                      v-if="$can('edit', 'inspections_attachments')"
                      >delete</v-icon
                    >
                  </span>
                </li>
              </div>
              <div v-else>
                <p class="font--primary">Brak powiązanych załączników</p>
              </div>
              <AddAttachment
                ref="childComponent"
                v-show="editing"
                @attachmentAdded="updateList"
                @attachmentDeleted="updateList"
                @confDialogOpened="triggerDialogAttach"
                :auto="true"
                :id_="hydrantData.id"
                :objectType="objectType"
                :objectTable="objectTable"
                :module="module"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap v-show="editing">
            <v-subheader class="font--primary"
              >ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader
            >
          </v-layout>
          <v-layout row wrap style="height: 90%" v-show="editing">
            <v-flex xs12>
              <DatabaseAttachments
                :objectIdCard="hydrantData.id"
                :objectTableCard="objectTable"
                :objectTypeCard="objectType"
                @attachmentAdded="updateList"
              />
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>
    </div>
  </Modal>
</template>

<script>
import AddAttachment from "../../../../shared/AddAttachment";
import DatabaseAttachments from "../../../table/attachments/DatabaseAttachments";
import InspectionsTable from "../../../table/InspectionsTable";
import Events from "../../../../shared/Events";
import Modal from "../../../../shared/Modal";
import moment from "moment";

export default {
  components: {
    AddAttachment,
    DatabaseAttachments,
    Events,
    Modal,
    InspectionsTable
  },
  data: () => ({
    attachmentsArr: [],
    chosenTask: undefined,
    dateMenu: false,
    dateMenu2: false,
    dateMenu3: false,
    editing: false,
    filter: "",
    formattedNID: undefined,
    formattedLID: undefined,
    formattedMD: undefined,
    hydrantData: {},
    hydrantDataCopy: undefined,
    hydrantKinds: [],
    id: undefined,
    inTasksList: [],
    isDisabled: true,
    isInTask: undefined,
    isMissedInspection: false,
    lastInspectionDate: undefined,
    module: "inspections",
    nearestInspection: undefined,
    newHydrantData: {
      inspection_date: new Date().toISOString().substr(0, 10),
      dateFormatted: undefined,
      external_examination: false,
      startup: false,
      static_pressure: false,
      dynamic_pressure: false,
      flow_rate: false,
      abduction: false,
      dynamic_pressure_value: undefined,
      static_pressure_value: undefined,
      comments: undefined,
      flow_rate_value: undefined,
      user_id: undefined
    },
    nextInspectionDate: undefined,
    notInTasksList: [],
    numberFiltered: "0",
    numberAll: "0",
    objectTable: "hydrants",
    objectType: "layers",
    parametersFields: {
      external_examination: "Oględziny zewnętrzene hydrantu",
      startup: "Uruchomienie/przepłukanie hydrantu",
      static_pressure: "Pomiar ciśnienia statycznego",
      dynamic_pressure: "Pomiar ciśnienia dynamicznego",
      flow_rate: "Pomiar natężenia wypływu",
      abduction: "Sprawdzenie skuteczności odwodnienia"
    },
    producers: [],
    selectedRow: undefined,
    statuses: [],
    valves: []
  }),
  watch: {
    chosenTask(val) {
      this.isDisabled = val == undefined ? true : false;
    },
    "hydrantData.measure_date"(val) {
      if (this.hydrantData.hydrantData)
        this.measure_date = this.formatDate(this.hydrantData.measure_date);
    },
    "hydrantData.next_inspection_date"(val) {
      if (this.hydrantData)
        this.next_inspection_date = this.formatDate(
          this.hydrantData.next_inspection_date
        );
    },
    "hydrantData.last_inspection_date"(val) {
      if (this.hydrantData)
        this.last_inspection_date = this.formatDate(
          this.hydrantData.last_inspection_date
        );
    },
    inspectionTasks() {
      if (
        this.hydrantData &&
        this.inspectionTasks &&
        this.inspectionTasks.tasks &&
        this.inspectionTasks.tasks.length != 0
      ) {
        this.inspectionTasks.tasks.forEach(element => {
          if (!element.hydrants.includes(this.hydrantData.id)) {
            this.notInTasksList.push(element);
          } else {
            this.inTasksList.push(element);
          }
        });
      }
    },
    inTasksList() {
      if (this.hydrantData) {
        let today = new Date();
        today.setHours(0, 0, 0);
        if (this.inTasksList.length != 0) {
          let closestTask = JSON.parse(JSON.stringify(this.inTasksList[0]));
          this.inTasksList.forEach(d => {
            var date = new Date(d.date_from);
            if (
              !date < today &&
              (date < new Date(closestTask.date_from) ||
                date < closestTask.date_from)
            ) {
              closestTask = d;
            }
          });
          this.nearestInspection = closestTask.inspections.filter(
            inspectionCard => {
              return (inspectionCard.hydrant = this.hydrantData.id);
            }
          )[0];
          this.isInTask = true;
        } else {
          this.isInTask = false;
        }
      }
    },
    "newHydrantData.inspection_date"(val) {
      if (this.newHydrantData)
        this.newHydrantData.dateFormatted = this.formatDate(
          this.newHydrantData.inspection_date
        );
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    computedInspectionDateFormatted() {
      if (this.newHydrantData["inspection_date"] == null) {
        this.$set(
          this.newHydrantData,
          "inspection_date",
          new Date().toISOString().substr(0, 10)
        );
        // return this.formatDate(new Date().toISOString().substr(0, 10))
      }
      return this.formatDate(this.newHydrantData.inspection_date.slice(0, 10));
    },
    computedMeasureDateFormatted() {
      if (this.hydrantData["measure_date"] != null) {
        return this.hydrantData.measure_date
          ? this.formatDate(this.hydrantData.measure_date.slice(0, 10))
          : "Brak pomiaru";
      }
    },
    computedNextDateFormatted() {
      if (this.hydrantData["next_inspection_date"] != null) {
        return this.formatDate(
          this.hydrantData.next_inspection_date.slice(0, 10)
        );
      }
    },
    computedLastDateFormatted() {
      if (this.hydrantData["last_inspection_date"] != null) {
        return this.formatDate(
          this.hydrantData.last_inspection_date.slice(0, 10)
        );
      }
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    inspectionTasks() {
      return this.$store.getters.getInspectionTasks;
    },
    users() {
      return this.$store.getters.getUsers.map(user => {
        return {
          name: user.name,
          id: user.id
        };
      });
    }
  },
  methods: {
    addArchiveInspection() {
      this.$root.$emit("addArchiveInspectionCard", this.hydrantData);
      this.show("addInspectionCardModal");
    },
    addNewInspection() {
      this.newHydrantData.hydrant = this.hydrantData.id;
      delete this.newHydrantData.dateFormatted;
      this.$store
        .dispatch("addHydrantInspection", this.newHydrantData)
        .then(r => {
          if (r) {
            this.newHydrantData = {};
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie dodano przegląd"
            );
            this.$root.$emit("edited_inspection");
          } else {
            this.$root.$emit("showSnackbar", "red", `${r}`);
          }
        });
    },
    cancelEditing() {
      this.hydrantData = this.hydrantDataCopy;
      this.editing = false;
    },
    completeInspection() {
      this.show("inspectionCardModal");
      this.$root.$emit("openedInspectionCard", [
        this.nearestInspection,
        this.hydrantData,
        true
      ]);
    },
    closed() {
      this.notInTasksList = [];
      this.inTasksList = [];
      this.newHydrantData = {};
      this.editing = false;
      this.chosenTask = undefined;
      this.$store.commit("setHydrantData", undefined);
      //this.$store.commit("setInspectionCards", []); //hotfix AC-1360
      this.formattedLID = null;
      this.formattedNID = null;
    },
    deleteAttachment(attachmentId) {
      this.$refs.childComponent.deleteAttachment(attachmentId);
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.childComponent.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    loadDict() {
      let payloadStatuses = {
        schema: "aquagis",
        table: "hydrants",
        column: "status"
      };
      this.$store.dispatch("getDictSTC", payloadStatuses).then(r => {
        this.statuses = r.values;
      });

      let payloadKinds = {
        schema: "aquagis",
        table: "hydrants",
        column: "hydrant_kind"
      };
      this.$store.dispatch("getDictSTC", payloadKinds).then(r => {
        this.hydrantKinds = r.values;
      });

      let payloadProducers = {
        schema: "aquagis",
        table: "hydrants",
        column: "producer"
      };
      this.$store.dispatch("getDictSTC", payloadProducers).then(r => {
        this.producers = r.values;
      });

      let payloadValves = {
        schema: "aquagis",
        table: "hydrants",
        column: "valve"
      };
      this.$store.dispatch("getDictSTC", payloadValves).then(r => {
        this.valves = r.values;
      });
    },
    loadHydrantData(data) {
      if (this.users.length < 1) {
        this.$store.dispatch("getUsers");
      }
      this.hydrantData = data.values_;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    print() {
      this.show("printHydrantCardModal");
      this.$root.$emit("printHydrantCard", this.hydrantData.id);
    },
    saveEditing() {
      let payload = {
        table: this.objectTable,
        body: {
          properties: JSON.parse(JSON.stringify(this.hydrantData)),
          ids: [this.hydrantData.id]
        }
      };
      this.$store.dispatch("editFeature", payload).then(success => {
        if (success) {
          this.$root.$emit("edited_hydrant");
          this.editing = false;
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas edytowania danych hydrantu wystąpił błąd"
          );
        }
      });
    },
    setInspectionDates(data) {
      this.isMissedInspection = false;
      if (data == undefined) {
        this.lastInspectionDate = "Brak daty ostatniej inspekcji";
        this.nextInspectionDate = "Brak daty kolejnej inspekcji";
        return;
      }

      let last = moment(data);
      let today = moment();
      let next = moment(data).add(12, "months");
      let next_date;

      if (today < next) {
        next_date = `(pozostało ${next.diff(today, "days")} dni)`;
      } else {
        next_date = `(${today.diff(next, "days")} dni temu)`;
        this.isMissedInspection = true;
      }

      this.lastInspectionDate = `${last.format("L")} (${today.diff(
        last,
        "days"
      )} dni temu)`;
      this.nextInspectionDate = `${next.format("L")} ${next_date}`;
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    startEditing() {
      delete this.hydrantData.geometry;
      this.hydrantDataCopy = JSON.parse(JSON.stringify(this.hydrantData));
      this.editing = true;
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    updateList() {
      let payload = {
        object_type: this.objectType,
        layer: this.objectTable,
        oid: this.hydrantData.id
      };
      this.$store.dispatch("getAttachmentsForObject", payload).then(r => {
        if (r) {
          this.attachmentsArr = this.$store.getters.getObjectAttachments;
        }
      });
    }
  },
  mounted() {
    this.$root.$on("deletedAttachmentGlobal", this.updateList);
    this.$root.$on("loadHydrantData", this.loadHydrantData);
    this.$root.$on("setInspectionDates", this.setInspectionDates);
    this.dateFormatted = this.formatDate(
      new Date().toISOString().substr(0, 10)
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/hydrants/modals/hydrants/HydrantCard.vue